module.exports = __webpack_public_path__ + "img/fastvaluedeal-table.2018e798.png";